import { ref, computed, reactive, nextTick } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.to-sorted.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-439ded9b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chart-title"
};
const _hoisted_2 = {
  class: "filters"
};
const _hoisted_3 = {
  key: 0,
  class: "content"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "date"
};
const _hoisted_6 = {
  class: "step-list"
};
const _hoisted_7 = {
  class: "num"
};
const _hoisted_8 = {
  class: "right"
};
import { DownOutlined } from '@ant-design/icons-vue';
import { getMonitorData } from '@/api/monitor';
import Empty from '@/components/Empty.vue';
import MonitorChart from './MonitorChart.vue';
import { reportEvent } from '@/common';
// 转化数悬浮窗格式化
export default /*#__PURE__*/_defineComponent({
  __name: 'PayPathChart',
  props: {
    title: {
      type: String,
      default: '付费路径转化情况(客户端)'
    }
  },
  setup(__props, {
    expose
  }) {
    const loading = ref(false);
    const chartData = ref([]);
    // 切换指标
    const fields = ref(['转化数', '转化率']);
    const currentField = ref('转化数');
    const handleFieldChange = e => {
      currentField.value = e.key;
      handleData();
    };
    // 图表类型
    const chartType = ref('trend');
    const charTypeName = computed(() => {
      var _chartTypeOptions$val;
      return (_chartTypeOptions$val = chartTypeOptions.value.find(item => item.value === chartType.value)) === null || _chartTypeOptions$val === void 0 ? void 0 : _chartTypeOptions$val.label;
    });
    const chartTypeOptions = ref([{
      label: '趋势图',
      value: 'trend'
    }
    // {
    //   label: '堆积图',
    //   value: 'stack',
    // },
    ]);
    const handleChartTypeChange = e => {
      chartType.value = e.key;
    };
    const overviewData = reactive({
      date: '',
      steps: []
    });
    // 左侧总览
    const stepMap = {
      start: '步骤一: 发起支付',
      create_order: '步骤二: 预下单',
      platform_buy: '步骤三: 调用支付API',
      complete: '步骤四: 支付成功',
      send_property: '步骤五: send_property'
    };
    const badgeColors = ['#319DEB', '#EB3131', '#F9AB13', '#39D313', '#31E0EB'];
    // 右侧图表
    const monitorChartRef = ref(null);
    const formatterNum = params => {
      var _params$;
      const hasCompare = chartData.value.some(itm => itm.metrics.some(m => !!m.compareMetric));
      let str = `<div>
    <div style="marign-bottom:12px;display:flex;align-items:center">
      <div style="width:160px;margin-right:24px">${hasCompare ? '' : (_params$ = params[0]) === null || _params$ === void 0 ? void 0 : _params$.axisValue}</div>
      <div style="width:75px;margin-right:24px">转化数</div>
      <div style="width:75px;margin-right:24px">环比</div>
      <div style="width:75px;">同比</div>
    </div>
    <div style="max-height: 400px;overflow: auto">`;
      params.forEach(item => {
        var _chartData$value$idx$, _chartData$value$idx;
        const idx = chartData.value.findIndex(c => item.seriesName.includes(c.groupColName));
        const data = (_chartData$value$idx$ = (_chartData$value$idx = chartData.value[idx]) === null || _chartData$value$idx === void 0 ? void 0 : _chartData$value$idx.metrics[item.dataIndex]) !== null && _chartData$value$idx$ !== void 0 ? _chartData$value$idx$ : {};
        if (!hasCompare) {
          var _data$currentMertic;
          const {
            weekOverWeekTotal,
            dayOverDayTotal
          } = (_data$currentMertic = data === null || data === void 0 ? void 0 : data.currentMertic) !== null && _data$currentMertic !== void 0 ? _data$currentMertic : {};
          str += `<div style="marign-bottom:12px;display:flex;align-items:center">
          <div style="width:160px;margin-right:24px;">${item.marker}${stepMap[item.seriesName]}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${item.value || item.value == 0 ? item.value : '-'}</span></div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${dayOverDayTotal}</span></div>
          <div style="width:75px;display:inline-block"><span style="font-weight: bold;">${weekOverWeekTotal}</span></div>
        </div>`;
        } else {
          var _data$currentMertic2;
          const {
            weekOverWeekTotal,
            dayOverDayTotal,
            dateTime,
            total
          } = (_data$currentMertic2 = data === null || data === void 0 ? void 0 : data.currentMertic) !== null && _data$currentMertic2 !== void 0 ? _data$currentMertic2 : {};
          if (!item.seriesName.includes('对比')) {
            str += `<div>${item.marker}${stepMap[item.seriesName]}</div>`;
            str += `<div style="marign-bottom:12px;display:flex;align-items:center">
          <div style="width:160px;margin-right:24px;padding-left:16px">${dateTime}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${total !== null && total !== void 0 ? total : '-'}</span></div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${dayOverDayTotal}</span></div>
          <div style="width:75px;display:inline-block"><span style="font-weight: bold;">${weekOverWeekTotal}</span></div>
        </div>`;
            const cItem = params.find(itm => itm.seriesName === '对比' + item.seriesName);
            if (cItem) {
              var _data$compareMetric;
              const {
                weekOverWeekTotal,
                dayOverDayTotal,
                dateTime,
                total
              } = (_data$compareMetric = data === null || data === void 0 ? void 0 : data.compareMetric) !== null && _data$compareMetric !== void 0 ? _data$compareMetric : {};
              str += `<div style="marign-bottom:12px;display:flex;align-items:center">
          <div style="width:160px;margin-right:24px;padding-left:16px">${dateTime}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${total !== null && total !== void 0 ? total : '-'}</span></div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${dayOverDayTotal}</span></div>
          <div style="width:75px;display:inline-block"><span style="font-weight: bold;">${weekOverWeekTotal}</span></div>
        </div>`;
            }
          } else if (!params.some(itm => !itm.seriesName.includes('对比'))) {
            var _data$compareMetric2;
            str += `<div>${item.marker}${stepMap[item.seriesName.split('对比')[1]]}</div>`;
            const {
              weekOverWeekTotal,
              dayOverDayTotal,
              dateTime,
              total
            } = (_data$compareMetric2 = data === null || data === void 0 ? void 0 : data.compareMetric) !== null && _data$compareMetric2 !== void 0 ? _data$compareMetric2 : {};
            str += `<div style="marign-bottom:12px;display:flex;align-items:center">
          <div style="width:160px;margin-right:24px;padding-left:16px">${dateTime}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${total !== null && total !== void 0 ? total : '-'}</span></div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${dayOverDayTotal}</span></div>
          <div style="width:75px;display:inline-block"><span style="font-weight: bold;">${weekOverWeekTotal}</span></div>
        </div>`;
          }
        }
      });
      str += '</div></div>';
      return str;
    };
    // 转化率悬浮窗格式化
    const formatterRate = params => {
      var _params$2;
      const hasCompare = chartData.value.some(itm => itm.metrics.some(m => !!m.compareMetric));
      let str = `<div>
    <div style="marign-bottom:12px;display:flex;align-items:center">
      <div style="width:160px;margin-right:24px">${hasCompare ? '' : (_params$2 = params[0]) === null || _params$2 === void 0 ? void 0 : _params$2.axisValue}</div>
      <div style="width:75px;margin-right:24px">转化率</div>
    </div>
    <div style="max-height: 400px;overflow: auto">`;
      params.forEach(item => {
        var _chartData$value$idx$2, _chartData$value$idx2;
        const idx = chartData.value.findIndex(c => item.seriesName.includes(c.groupColName));
        const data = (_chartData$value$idx$2 = (_chartData$value$idx2 = chartData.value[idx]) === null || _chartData$value$idx2 === void 0 ? void 0 : _chartData$value$idx2.metrics[item.dataIndex]) !== null && _chartData$value$idx$2 !== void 0 ? _chartData$value$idx$2 : {};
        if (!hasCompare) {
          var _data$currentMertic$r;
          str += `<div style="marign-bottom:12px;display:flex;    align-items:center">
          <div style="width:160px;margin-right:24px;>${item.marker}${stepMap[item.seriesName]}</div>
          <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${(_data$currentMertic$r = data.currentMertic.rate) !== null && _data$currentMertic$r !== void 0 ? _data$currentMertic$r : '-'}</span></div>
        </div>`;
        } else {
          if (!item.seriesName.includes('对比')) {
            var _data$currentMertic$r2;
            str += `<div>${item.marker}${stepMap[item.seriesName]}</div>`;
            str += `<div style="marign-bottom:12px;display:flex;    align-items:center">
            <div style="width:160px;margin-right:24px;padding-left:'16px'">${item.axisValue}</div>
            <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${(_data$currentMertic$r2 = data.currentMertic.rate) !== null && _data$currentMertic$r2 !== void 0 ? _data$currentMertic$r2 : '-'}</span></div>
          </div>`;
            const cItem = params.find(itm => itm.seriesName === '对比' + item.seriesName);
            if (cItem) {
              var _data$compareMetric$r;
              str += `<div style="marign-bottom:12px;display:flex;    align-items:center">
            <div style="width:160px;margin-right:24px;padding-left:'16px'">${cItem.axisValue}</div>
            <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${(_data$compareMetric$r = data.compareMetric.rate) !== null && _data$compareMetric$r !== void 0 ? _data$compareMetric$r : '-'}</span></div>
          </div>`;
            }
          } else if (!params.some(itm => !itm.seriesName.includes('对比'))) {
            var _data$currentMertic$r3;
            str += `<div>${item.marker}${stepMap[item.seriesName.split('对比')[1]]}</div>`;
            str += `<div style="marign-bottom:12px;display:flex;    align-items:center">
            <div style="width:160px;margin-right:24px;padding-left:'16px'">${item.axisValue}</div>
            <div style="width:75px;margin-right:24px"><span style="font-weight: bold;">${(_data$currentMertic$r3 = data.currentMertic.rate) !== null && _data$currentMertic$r3 !== void 0 ? _data$currentMertic$r3 : '-'}</span></div>
          </div>`;
          }
        }
      });
      str += '</div></div>';
      return str;
    };
    // 处理图表数据
    const handleData = () => {
      let xAxis = [];
      const seriesData = [];
      const legends = [];
      overviewData.steps = [];
      chartData.value.forEach((item, i) => {
        const {
          groupColName,
          metrics
        } = item;
        const lastMetric = metrics[metrics.length - 1];
        overviewData.date = lastMetric.currentMertic.dateTime;
        // 转化数不显示步骤五，转化率不显示步骤一
        if (currentField.value === '转化数' && i !== chartData.value.length - 1 || currentField.value === '转化率' && i !== 0 && i !== chartData.value.length - 1) {
          var _lastMetric$currentMe, _lastMetric$currentMe2;
          const name = stepMap[item.groupColName];
          overviewData.steps.push({
            value: currentField.value === '转化数' ? (_lastMetric$currentMe = lastMetric.currentMertic.total) !== null && _lastMetric$currentMe !== void 0 ? _lastMetric$currentMe : '' : (_lastMetric$currentMe2 = lastMetric.currentMertic.rate) !== null && _lastMetric$currentMe2 !== void 0 ? _lastMetric$currentMe2 : '',
            name,
            color: badgeColors[i]
          });
          if (xAxis.length === 0) {
            xAxis.push({
              type: 'category',
              boundaryGap: false,
              data: metrics.map(m => {
                return m.currentMertic.dateTime;
              })
            });
          }
          legends.push({
            name: item.groupColName,
            itemStyle: {
              color: badgeColors[i]
            }
          });
          seriesData.push({
            name: groupColName,
            type: 'line',
            lineStyle: {
              type: 'solid',
              color: badgeColors[i]
            },
            itemStyle: {
              color: badgeColors[i]
            },
            data: metrics.map(m => {
              if (currentField.value === '转化数') {
                var _m$currentMertic$tota;
                return (_m$currentMertic$tota = m.currentMertic.total) !== null && _m$currentMertic$tota !== void 0 ? _m$currentMertic$tota : '';
              } else {
                var _m$currentMertic$rate;
                if ((_m$currentMertic$rate = m.currentMertic.rate) !== null && _m$currentMertic$rate !== void 0 && _m$currentMertic$rate.includes('%')) {
                  return m.currentMertic.rate.split('%')[0];
                }
                if (m.currentMertic.rate === -1 || m.currentMertic.rate === null) {
                  return 0;
                } else {
                  return m.currentMertic.rate;
                }
              }
            }),
            xAxisIndex: 0,
            symbol: 'circle',
            symbolSize: 5
          });
          if (metrics[0].compareMetric) {
            const seriesName = '对比' + groupColName;
            seriesData.push({
              name: seriesName,
              type: 'line',
              lineStyle: {
                type: 'dashed',
                color: badgeColors[i]
              },
              data: metrics.map(m => {
                if (currentField.value === '转化数') {
                  var _m$compareMetric$tota;
                  return (_m$compareMetric$tota = m.compareMetric.total) !== null && _m$compareMetric$tota !== void 0 ? _m$compareMetric$tota : '';
                } else {
                  var _m$compareMetric$rate;
                  if ((_m$compareMetric$rate = m.compareMetric.rate) !== null && _m$compareMetric$rate !== void 0 && _m$compareMetric$rate.includes('%')) {
                    return m.compareMetric.rate.split('%')[0];
                  }
                  if (m.compareMetric.rate === -1 || m.compareMetric.rate === null) {
                    return 0;
                  } else {
                    return m.compareMetric.rate;
                  }
                }
              }),
              xAxisIndex: 1,
              symbol: 'circle',
              symbolSize: 5
            });
            if (xAxis.length === 1) {
              xAxis.push({
                type: 'category',
                boundaryGap: false,
                position: 'bottom',
                offset: 16,
                axisLine: {
                  show: false
                },
                data: metrics.map(m => {
                  return m.compareMetric.dateTime;
                })
              });
            }
          }
        }
      });
      nextTick(() => {
        var _monitorChartRef$valu;
        const options = {
          tooltip: {
            trigger: 'axis',
            enterable: true,
            formatter: currentField.value === '转化数' ? formatterNum : formatterRate
          },
          color: currentField.value === '转化数' ? badgeColors.slice(0, 4) : badgeColors.slice(1, 4),
          legend: {
            data: legends,
            top: '93%',
            icon: 'circle',
            itemWidth: 10,
            formatter: function (name) {
              return stepMap[name];
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '10%',
            top: 24,
            containLabel: true
          },
          xAxis,
          yAxis: {
            type: 'value'
          },
          series: seriesData.toSorted((a, b) => a.xAxisIndex - b.xAxisIndex)
        };
        (_monitorChartRef$valu = monitorChartRef.value) === null || _monitorChartRef$valu === void 0 || _monitorChartRef$valu.createChart(options);
      });
    };
    // 获取接口数据
    const getData = params => {
      loading.value = true;
      const startTime = new Date().getTime();
      getMonitorData(params).then(res => {
        if (res.code === '0') {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '监控看板付费路径转化情况(客户端)搜索',
              app_name: '',
              return_duration: new Date().getTime() - startTime,
              query_status: 'succeed'
            }
          });
          chartData.value = res.data;
        } else {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '监控看板付费路径转化情况(客户端)搜索',
              app_name: '',
              return_duration: new Date().getTime() - startTime,
              query_status: 'failed'
            }
          });
          chartData.value = [];
        }
        handleData();
        loading.value = false;
      }).catch(err => {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '监控看板付费路径转化情况(客户端)搜索',
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'failed'
          }
        });
        loading.value = false;
      });
    };
    expose({
      getData
    });
    return (_ctx, _cache) => {
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_badge = _resolveComponent("a-badge");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_space, {
        size: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_dropdown, {
          trigger: ['click']
        }, {
          overlay: _withCtx(() => [_createVNode(_component_a_menu, {
            onClick: handleFieldChange
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, field => {
              return _openBlock(), _createBlock(_component_a_menu_item, {
                key: field
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(field), 1)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("a", {
            class: "ant-dropdown-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [_createTextVNode(_toDisplayString(currentField.value) + " ", 1), _createVNode(_unref(DownOutlined))])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_dropdown, {
        trigger: ['click']
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, {
          onClick: handleChartTypeChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartTypeOptions.value, item => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: item.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("a", {
          class: "ant-dropdown-link",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [_createTextVNode(_toDisplayString(_unref(charTypeName)) + " ", 1), _createVNode(_unref(DownOutlined))])]),
        _: 1
      })]), _createVNode(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => {
          var _chartData$value;
          return [(_chartData$value = chartData.value) !== null && _chartData$value !== void 0 && _chartData$value.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(overviewData.date), 1), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overviewData.steps, (step, i) => {
            return _openBlock(), _createElementBlock("div", {
              class: "step",
              key: i
            }, [_createElementVNode("div", _hoisted_7, _toDisplayString(step.value), 1), _createVNode(_component_a_badge, {
              color: step.color,
              text: step.name
            }, null, 8, ["color", "text"])]);
          }), 128))])]), _createElementVNode("div", _hoisted_8, [_createVNode(MonitorChart, {
            ref_key: "monitorChartRef",
            ref: monitorChartRef,
            chartId: __props.title
          }, null, 8, ["chartId"])])])) : (_openBlock(), _createBlock(Empty, {
            key: 1
          }))];
        }),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});